import { memo as Memo, useMemo } from 'react';

//* HOC
import withDataContext from 'context/consumerHOC/DataConsumer';

//* Components
import Page from 'components/common/Page';
import EventHero from 'components/pages/post/EventHeroSection';
import LatestNews from 'components/pages/post/LatestNewsSection';
import ProductsSliderSection from 'components/common/ProductsSliderSection';

const NewsAndEvents = Memo(({ pages, global, pageParams, config, selectedLang }) => {
	//! Global Data
	const globalData = useMemo(() => global?.[selectedLang], [global, selectedLang]);

	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams]);

	return (
		<Page
			meta={pageData?.content?.meta}
			className={'news-and-event'}
			jsonLdType={'blog'}>
			{pageData && (
				<>
					{pageData.posts.event && pageData.posts.event.length > 0 && (
						<EventHero data={pageData.posts.event} />
					)}

					{pageData.posts.news && pageData.posts.news.length > 0 && (
						<LatestNews
							isLoadMore
							title={`latestNews`}
							data={pageData.posts.news}
							className={`${
								!(pageData.posts.event && pageData.posts.event.length > 0) ? 'not-event' : ''
							}`}
						/>
					)}

					{globalData && globalData?.popular_products && globalData?.popular_products.length > 0 && (
						<ProductsSliderSection
							title={`popularProducts`}
							products={globalData['popular_products']}
							button={{ url: config.products.slug, text: 'seeAllProducts' }}
						/>
					)}
				</>
			)}
		</Page>
	);
});

export default withDataContext(NewsAndEvents, ['pages', 'global']);
